var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackgroundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1052,
    height: 119,
    viewBox: "0 0 1052 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4761 58.8037L1000.36 58.794",
    stroke: "url(#paint0_linear_1623_1317)",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38243 117.657L140.956 1.5H948.217L1050.51 117.657H1.38243Z",
    stroke: "url(#paint1_radial_1623_1317)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 728.838,
    y1: 0.723161,
    x2: 806.529,
    y2: 117.569,
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 837.608,
    y1: 0.723161,
    x2: 915.298,
    y2: 117.569,
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 604.54,
    y1: 1.34789,
    x2: 680.366,
    y2: 117.573,
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 140.317,
    y2: -0.5,
    transform: "matrix(-0.553678 0.832731 0.832731 0.553678 322.57 1)",
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 140.317,
    y2: -0.5,
    transform: "matrix(-0.553678 0.832731 0.832731 0.553678 213.805 1)",
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 138.772,
    y2: -0.5,
    transform: "matrix(-0.546404 0.837521 0.837521 0.546404 446.875 1.62109)",
    stroke: "#323337",
    strokeOpacity: 0.88
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1623_1317",
    x1: 121.069,
    y1: 77.8666,
    x2: 1012.42,
    y2: 86.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#26D36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0DB2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF005C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1623_1317",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(518.66 39.8451) rotate(67.7115) scale(95.0467 853.151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F56A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000001"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackgroundImage);
export default __webpack_public_path__ + "static/media/footer-background-image.be345081fdcf78fe75debf32c83e6ddc.svg";
export { ForwardRef as ReactComponent };